import React from 'react';

import { useStyles } from './styles';

interface INeedleProps {
  style?: React.CSSProperties;
}

const Neddle: React.FC<INeedleProps> = ({ style }) => {
  const classes = useStyles();

  return (
    <div className={classes.container} style={style}>
      <div className={classes.arrow} />
      <div className={classes.end} />
    </div>
  );
};

export default Neddle;
